import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { AppService } from "../services/app.service";
import { HttpService } from "../services/http.service";
import { AmplifyService } from "../services/amplify.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { AlertController } from "@ionic/angular";
import { Listen } from "ionicons/dist/types/stencil-public-runtime";
import { Title } from "@angular/platform-browser";
import { link } from "fs";

declare var mapsAutocomplete;
declare var mapsLocationDetails;
declare var mappedinDirectory;

@Component({
  selector: "app-sites-edit",
  templateUrl: "./sites-edit.page.html",
  styleUrls: ["./sites-edit.page.scss"],
})
export class SitesEditPage implements OnInit {
  private slug: any;
  flags: any;
  ads: string;
  public isColumnVisible = true;
  duplicateCompanyID: any;
  realtorTemplates: any[] = [];
  deviceData: any;
  copyLinkAPChosen = null;
  entryIDChosen = null;

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.checkScreenSize();
  }

  @ViewChild("copySelect") selectRef: any;
  constructor(
    public app: AppService,
    public http: HttpService,
    public amplify: AmplifyService,
    private location: Location,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public alertController: AlertController,
    public title: Title
  ) {
    this.checkScreenSize();
    this.ads = "upper-ads"; // Setting upper-ads to default
    this.flags = {
      section: "a",
      fontList: [
        "Verdana",
        "Georgia",
        "Arial",
        "Serif",
        "Sans-Serif",
        "Times New Roman",
        "Candara",
        "Calibri",
        "Optima",
        "Lucida Bright",
        "Cera GR Light",
        "Cera GR Medium",
        "Cera GR Bold",
        "Typold Regular",
        "Typold Medium",
        "Typold Extra Bold",
        "Proxima Nova",
        "Proxima Nova Bold",
        "Montserrat Thin",
        "Montserrat Regular",
        "Montserrat Medium",
        "Montserrat Bold",
        "Montserrat Extra Bold",
        "Roboto Light",
        "Roboto Regular",
        "Roboto Medium",
        "Roboto Bold",
        "Open Sans Regular",
        "Open Sans Light",
        "Open Sans Semi Bold",
        "Open Sans Bold",
      ],
      fontSizeList: [
        8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 65,
        70, 75, 80, 85, 90, 95, 100,
      ],
      newPublicCategory: { name: null },
      newPrivateCategory: { name: null },

      directoryListings: null,

      sitesList: [],
      sitesResults: [],

      slideList: [],
      scale: 1,

      addressSearch: null,
      matches: { address: [], googleResult: [], patientsGroup: [] },

      categoryList: [],
      editCategory: { id: "a" },

      defaultCategory: {
        site_id: null,
        priority: 0,
        name: null,
        language: "en",
        type: 1,
        entries: [],
        settings: {
          text: "",
          textOverride: false,
          textColor: "#333",
          textFont: "Verdana",
          textSize: "20",
          bgColor: "#efefef",
          bgImage: null,
          width: "98%",
          buttonShape: "none",
          catGlassmorphism: 0,
          buttonTemplate: "default",
          catFeatureAsNew: false,
          buttonSubheading: null,
          realtorTemplateAvatar: null,
          featuredPropertyImage: null,
          realtorButtonTemplateBG: {
            template: {
              template_blue: "assets/img/realtor-template-blue.jpg",
              template_white: "assets/img/realtor-template-white.jpg",
              template_black: "assets/img/realtor-template-black.jpg",
              template_gray: "assets/img/realtor-template-gray.jpg",
              template_about_gray: "assets/img/realtor-template-about-gray.jpg",
              template_about_dark_blue: "assets/img/realtor-template-about-dark-blue.jpg",
              template_about_blue: "assets/img/realtor-template-about-blue.jpg",
            },
            remax: {
              remax_blue: "assets/img/realtor-remax-blue.jpg",
              remax_red: "assets/img/realtor-remax-red.jpg",
              remax_about_red: "assets/img/realtor-remax-about-red.jpg",
              remax_about_gray: "assets/img/realtor-remax-about-gray.jpg",
              remax_about_white: "assets/img/realtor-remax-about-white.jpg",
              remax_about_dark_blue: "assets/img/realtor-remax-about-dark-blue.jpg",
              remax_about_dark_gray: "assets/img/realtor-remax-about-dark-gray.jpg",
            },
            exp: {
              exp_blue: "assets/img/realtor-exp-blue.jpg",
              exp_white: "assets/img/realtor-exp-white.jpg",
              exp_black: "assets/img/realtor-exp-black.jpg",
              exp_gray: "assets/img/realtor-exp-gray.jpg",
              exp_about_gray: "assets/img/realtor-exp-about-gray.jpg",
              exp_about_dark_blue: "assets/img/realtor-exp-about-dark-blue.jpg",
              exp_about_blue: "assets/img/realtor-exp-about-blue.jpg",
            },
            royalLePage: {
              royalLePage_black: "assets/img/realtor-royalLePage-black.jpg",
              royalLePage_white: "assets/img/realtor-royalLePage-white.jpg",
              royalLePage_white_border: "assets/img/realtor-royalLePage-white-2.jpg",
              royalLepage_about_white: "assets/img/realtor-royallepage-about-white.jpg",
              royalLepage_about_black: "assets/img/realtor-royallepage-about-black.jpg",
              royalLepage_about_black_2: "assets/img/realtor-royallepage-about-black-2.jpg",
              royalLepage_about_gray: "assets/img/realtor-royallepage-about-gray.jpg",
            },
            century21: {
              century21_black: "assets/img/realtor-century21-black.jpg",
              century21_white: "assets/img/realtor-century21-white.jpg",
              century21_gold: "assets/img/realtor-century21-gold.jpg",
              century21_black_simple: "assets/img/realtor-century21-black-simple.jpg",
              century21_about_gold: "assets/img/realtor-century21-about-gold.jpg",
              century21_about_gold_2: "assets/img/realtor-century21-about-gold-2.jpg",
              century21_about_gray: "assets/img/realtor-century21-about-gray.jpg",
            },
            liv: {
              liv_white: "assets/img/realtor-liv-white.jpg",
              liv_blue: "assets/img/realtor-liv-blue.jpg",
              liv_blue_simple: "assets/img/realtor-liv-blue-simple.jpg",
              liv_about_blue: "assets/img/realtor-liv-about-teal.jpg",
              liv_about_gray: "assets/img/realtor-liv-about-gray.jpg",
            },
          },
        },
      },

      defaultEntry: {
        id: null,
        name: null,
        type: "website",
        target: null,
        contact: {
          phone: null,
          email: null,
          address: null,
          city: null,
          state: null,
          country: null,
          zip: null,
        },
        controls: { dc: true, qr: true, txt: true },
        settings: {
          text: "",
          textOverride: false,
          textColor: "#333",
          textFont: "Verdana",
          textSize: "20",
          bgColor: "#efefef",
          bgImage: null,
          width: "98%",
          buttonShape: "none",
          catGlassmorphism: 0,
          buttonTemplate: "default",
          featureAsNew: false,
          videoCTAButton: false,
          videoCTADetails: {
            text: "Click Me",
            textColor: "#ffffff",
            textFont: "Verdana",
            textSize: "16",
            bgColor: "#6d1cdd",
            target: null,
          },
          realtorTemplateAvatar: null,
          realtorButtonTemplateBG: {
            template: {
              template_blue: "assets/img/realtor-template-blue.jpg",
              template_white: "assets/img/realtor-template-white.jpg",
              template_black: "assets/img/realtor-template-black.jpg",
              template_gray: "assets/img/realtor-template-gray.jpg",
              template_about_gray: "assets/img/realtor-template-about-gray.jpg",
              template_about_dark_blue: "assets/img/realtor-template-about-dark-blue.jpg",
              template_about_blue: "assets/img/realtor-template-about-blue.jpg",
            },
            remax: {
              remax_blue: "assets/img/realtor-remax-blue.jpg",
              remax_red: "assets/img/realtor-remax-red.jpg",
              remax_about_red: "assets/img/realtor-remax-about-red.jpg",
              remax_about_gray: "assets/img/realtor-remax-about-gray.jpg",
              remax_about_white: "assets/img/realtor-remax-about-white.jpg",
              remax_about_dark_blue: "assets/img/realtor-remax-about-dark-blue.jpg",
              remax_about_dark_gray: "assets/img/realtor-remax-about-dark-gray.jpg",
            },
            exp: {
              exp_blue: "assets/img/realtor-exp-blue.jpg",
              exp_white: "assets/img/realtor-exp-white.jpg",
              exp_black: "assets/img/realtor-exp-black.jpg",
              exp_gray: "assets/img/realtor-exp-gray.jpg",
              exp_about_gray: "assets/img/realtor-exp-about-gray.jpg",
              exp_about_dark_blue: "assets/img/realtor-exp-about-dark-blue.jpg",
              exp_about_blue: "assets/img/realtor-exp-about-blue.jpg",
            },
            royalLePage: {
              royalLePage_black: "assets/img/realtor-royalLePage-black.jpg",
              royalLePage_white: "assets/img/realtor-royalLePage-white.jpg",
              royalLePage_white_border: "assets/img/realtor-royalLePage-white-2.jpg",
              royalLepage_about_white: "assets/img/realtor-royallepage-about-white.jpg",
              royalLepage_about_black: "assets/img/realtor-royallepage-about-black.jpg",
              royalLepage_about_black_2: "assets/img/realtor-royallepage-about-black-2.jpg",
              royalLepage_about_gray: "assets/img/realtor-royallepage-about-gray.jpg",
            },
            century21: {
              century21_black: "assets/img/realtor-century21-black.jpg",
              century21_white: "assets/img/realtor-century21-white.jpg",
              century21_gold: "assets/img/realtor-century21-gold.jpg",
              century21_black_simple: "assets/img/realtor-century21-black-simple.jpg",
              century21_about_gold: "assets/img/realtor-century21-about-gold.jpg",
              century21_about_gold_2: "assets/img/realtor-century21-about-gold-2.jpg",
              century21_about_gray: "assets/img/realtor-century21-about-gray.jpg",
            },
            liv: {
              liv_white: "assets/img/realtor-liv-white.jpg",
              liv_blue: "assets/img/realtor-liv-blue.jpg",
              liv_blue_simple: "assets/img/realtor-liv-blue-simple.jpg",
              liv_about_blue: "assets/img/realtor-liv-about-teal.jpg",
              liv_about_gray: "assets/img/realtor-liv-about-gray.jpg",
            },
          },
        },
      },
      defaultAdEntry: {
        id: null,
        name: null,
        type: "image",
        target: null,
        ad_link: null,
        ad_tag: true,
      },
      defaultSessionReasonEntry: {
        reason: null,
      },

      defaultSite: {
        company_id: this.app.sysData.company_id,
        epoch: null,
        name: null,
        phone_numbers: null,
        address: null,
        city: null,
        state: null,
        country: null,
        zip: null,
        place_id: null,
        lat: null,
        lng: null,
        language: "en",
        notes: null,
        self_serve: [],
        directory: [],
        api_directory: [],
        contacts: [],
        settings: {
          mapsLink: null,
          directory: { type: "null" },
          theme: "light",
          title: "Find answers",
          subtitle: "Search, or browse through the topics below to find answers to your questions.",
          contactTitle: "Need assistance?",
          contactSubtitle: "Talk to a live person",
          supportPhone: "Contact us by phone at 555-555-5555",
          supportSMS: "Text message your questions to 555-555-5555",
          supportEmail: "Please email us your questions at help@domain.com",
          wVideo: null,
          wVideoStyle: "normal",
          wVideoBgColor: "#ffffff",
          sVideo: null,
          sVideoStyle: "normal",
          sVideoBgColor: "#ffffff",
          showAds: 0,
          showContactCard: 1,
          upperAdvertisementList: [],
          lowerAdvertisementList: [],
          wImageLoop: null,
          sessionReasonsList: [],
          realtorCompany: null,
          siteSocialMedia: [],
        },
      },

      viewSite: null,
      newSite: null,
      editSite: null,

      focus: 0,
    };

    this.flags.defaultAdEntry.ad_tag = true;
    this.flags.defaultCategory.settings.buttonTemplate = "default";
    this.flags.defaultEntry.settings.buttonTemplate = "default";

    this.slug = this.activatedRoute.snapshot.paramMap.get("id");
    this.getData();
  }

  ionViewDidEnter() {
    this.title.setTitle("Edit - " + this.flags.editSite.name);
  }
  checkScreenSize() {
    // This ensures that on larger screens, the visibility is handled automatically,
    // but on smaller screens, the column remains visible unless toggled.
    if (window.innerWidth >= 768) {
      this.isColumnVisible = true; // Always visible on larger screens
      return true;
    } else {
      // Do not automatically hide on mobile; respect the current toggle state
      // Remove or comment out this line if you want it always visible when reloading the page on mobile:
      // this.isColumnVisible = false;
      return false;
    }
  }

  toggleColumn() {
    if (window.innerWidth < 768) {
      // Change 768 to your desired breakpoint for smaller screens
      this.isColumnVisible = !this.isColumnVisible;
    }
  }

  getData() {
    if (this.slug == 0) {
      //new site
      this.flags.editSite = JSON.parse(JSON.stringify(this.flags.defaultSite));
    } else {
      //existing slide
      this.http.apiGet("company_sites/id/" + this.slug, null).then((data) => {
        console.log("get slide", data.data);
        var obj = data.data[0];

        obj.settings = JSON.parse(obj.settings);
        obj.self_serve = JSON.parse(obj.self_serve);
        obj.directory = JSON.parse(obj.directory);
        obj.api_directory = JSON.parse(obj.api_directory);
        obj.contacts = JSON.parse(obj.contacts);

        this.flags.editSite = obj;

        this.reset();
        this.getCategories();
        this.initSessionReasons(this.app.sysData.company.industry);
        this.initSiteSocialMedia();
      });
    }
  }

  reset() {
    this.flags.newPrivateCategory = JSON.parse(JSON.stringify(this.flags.defaultCategory));
    this.flags.newPublicCategory = JSON.parse(JSON.stringify(this.flags.defaultCategory));

    this.flags.editCategory = { id: "a" };
  }

  openDuplicateSelect() {
    this.selectRef.open();
  }

  duplicateSite() {
    var obj = JSON.parse(JSON.stringify(this.flags.defaultSite));
    obj.epoch = Date.now();
    obj.name = " Copy of " + this.flags.editSite.name;
    obj.company_id = this.duplicateCompanyID;
    obj.self_serve = JSON.stringify(this.flags.editSite.self_serve);
    obj.directory = JSON.stringify(this.flags.editSite.directory);
    obj.api_directory = JSON.stringify(this.flags.editSite.api_directory);
    obj.contacts = JSON.stringify(this.flags.editSite.contacts);
    obj.settings = JSON.stringify(this.flags.editSite.settings);
    console.log("DUPLICATING SITE >>> ", this.flags.categoryList);
    console.log("Looking for company ids >>> ", this.app.sysData);

    // this.flags.editCategory.entries = JSON.parse(this.flags.modalItem.editEntries);
    // this.flags.editCategory.settings = JSON.parse(this.flags.modalItem.editSettings);

    // this.flags.editSite.settings = JSON.parse(this.flags.modalItem.editSettings);
    // this.flags.editSite.directory = JSON.parse(this.flags.modalItem.editDirectory);
    // this.flags.editSite.contacts = JSON.parse(this.flags.modalItem.editContacts);

    this.app.load("Duplicating Experience", 500);

    this.http.apiPost("company_sites", { data: obj }, null).then((data) => {
      //this.app.toast('Saved', 'success');
      console.log(data);
      var id = data["data"].insertId;
      if (id) {
        this.app.toast("Experience is  copied", "success");
        // Copying Categories & Entries
        // var categories = JSON.parse(JSON.stringify(this.flags.categoryList));
        // // Change site_id to new site id
        // categories.forEach((category) => {
        //   category.site_id = id;

        //   this.http.apiPost("repo_categories/", { data: category }, null);
        // });

        // console.log("DUPLICATING CATEGORIES MAYBE COMING HERE >>> ", categories);
        // this.router.navigateByUrl("/sites-edit/" + id);
        //this.flags.sessionID = data['data'].insertId;
        //this.app.alert(data.data.insertId);
        //this.subscribe();

        this.app.stopload();
      } else {
        this.app.alert("Error occured please try again");
      }

      //this.getSites();
      //this.reset();
    });
  }

  newEntry() {
    var obj = JSON.parse(JSON.stringify(this.flags.defaultEntry));
    obj.id = Date.now();

    console.log("NEW ENTRY", obj);
    this.flags.editCategory.entries.push(obj);
  }

  initSiteSocialMedia() {
    if (!Array.isArray(this.flags.editSite.settings.siteSocialMedia)) {
      this.flags.editSite.settings.siteSocialMedia = [];
    }
    if (this.flags.editSite.settings.siteSocialMedia.length === 0) {
      this.flags.editSite.settings.siteSocialMedia = [
        { type: "facebook", link: null },
        { type: "twitter", link: null },
        { type: "instagram", link: null },
        { type: "linkedin", link: null },
        { type: "youtube", link: null },
        { type: "tiktok", link: null },
      ];
    }
    console.log("init site social media", this.flags.editSite.settings.siteSocialMedia);
  }

  initSessionReasons(m) {
    if (!Array.isArray(this.flags.editSite.settings.sessionReasonsList)) {
      this.flags.editSite.settings.sessionReasonsList = [];
    }

    if (this.flags.editSite.settings.sessionReasonsList.length === 0) {
      if (m === "retail") {
        this.flags.editSite.settings.sessionReasonsList = [
          { reason: "Directory" },
          { reason: "Entertainment" },
          { reason: "Food & Beverage" },
          { reason: "Safety & Security" },
          { reason: "Transportation" },
          { reason: "Tenant" },
          { reason: "Other" },
        ];
      } else if (m === "real-estate") {
        this.flags.editSite.settings.sessionReasonsList = [
          { reason: "Buying" },
          { reason: "Selling" },
          { reason: "Mortgages" },
          { reason: "Home Inspection" },
          { reason: "Legal" },
          { reason: "Property Evaluation" },
          { reason: "Property Search" },
          { reason: "Other" },
        ];
      }
    }
    console.log("init session reasons", m, this.flags.editSite.settings.sessionReasonsList);
    console.log(this.app.sysData.company.industry);
  }

  newSessionReasonEntry() {
    var obj = JSON.parse(JSON.stringify(this.flags.defaultSessionReasonEntry));
    this.flags.editSite.settings.sessionReasonsList.push(obj);
    console.log("NEW SESSION REASON ENTRY", obj);
    console.log("FULL REASON LIST >>> " + this.flags.editSite.settings.sessionReasonsList);
  }

  newAdEntry(m) {
    if (m == "upper") {
      var obj = JSON.parse(JSON.stringify(this.flags.defaultAdEntry));
      obj.id = Date.now();
      // this.flags.editSite.settings.upperAdvertisementList = [];
      if (!Array.isArray(this.flags.editSite.settings.upperAdvertisementList)) {
        this.flags.editSite.settings.upperAdvertisementList = [];
      }

      console.log("NEW AD ENTRY", obj);
      this.flags.editSite.settings.upperAdvertisementList.push(obj);
    }
    if (m == "lower") {
      var obj = JSON.parse(JSON.stringify(this.flags.defaultAdEntry));
      obj.id = Date.now();
      if (!Array.isArray(this.flags.editSite.settings.lowerAdvertisementList)) {
        this.flags.editSite.settings.lowerAdvertisementList = [];
      }

      console.log("NEW AD ENTRY", obj);
      this.flags.editSite.settings.lowerAdvertisementList.push(obj);
    }
  }

  //aCATEGORIES

  getCategories() {
    this.http
      .apiGet("repo_categories/site_id/" + this.flags.editSite.id + "?&orderby=type+asc:priority:name", null)
      .then((data) => {
        var obj = data.data;
        this.flags.categoryList = obj;
        console.log("CATEGORY List", data.data);
      });
  }

  editCategory(m, id) {
    //done

    if (m == 1) {
      this.flags.editCategory = { id: id };
    }
    if (m == 1.1) {
      //if editing existing category

      var obj = this.flags.categoryList.find((el) => el.id === id);
      obj = JSON.parse(JSON.stringify(obj));
      obj.entries = JSON.parse(obj.entries);
      obj.settings = JSON.parse(obj.settings);
      this.flags.editCategory = JSON.parse(JSON.stringify(obj));
    }
  }

  copyLinkToClipboard(linkType, entryID) {
    console.log("DEVICES >>> ", this.deviceData, "And the length is >>> ", this.deviceData.length);
    if (this.deviceData.length === 0) {
      this.app.presentToast("No Access Points found. Please add one before you copy the link.", "danger");
    } else if (this.deviceData.length === 1) {
      this.copyLinkAPChosen = this.deviceData[0].token;
    } else if (this.deviceData.length > 1 && linkType == 1) {
      this.openModal(5, null);
    } else if (this.deviceData.length > 1 && linkType == 2) {
      if (entryID != null) {
        this.entryIDChosen = entryID;
      }
      this.openModal(6, null);
    }

    if (linkType == 1 && this.copyLinkAPChosen != null) {
      if (this.flags.modalMode != null) {
        this.flags.modalMode = null;
      }
      navigator.clipboard.writeText(
        "https://wecare.helloarii.com/e/" +
          this.copyLinkAPChosen +
          "/params?siteID=" +
          this.flags.editSite.id +
          "&folderID=" +
          this.flags.editCategory.id
      );
      this.app.presentToast("Link copied", "success");
    } else if (linkType == 2 && this.copyLinkAPChosen != null) {
      if (entryID != null) {
        this.entryIDChosen = entryID;
      }
      if (this.flags.modalMode != null) {
        this.flags.modalMode = null;
      }
      console.log("Entry List >>> ", this.flags.editCategory.entries);
      console.log("ENTRY ID CHOSEN >>> ", this.entryIDChosen);
      navigator.clipboard.writeText(
        "https://wecare.helloarii.com/e/" +
          this.copyLinkAPChosen +
          "/params?siteID=" +
          this.flags.editSite.id +
          "&folderID=" +
          this.flags.editCategory.id +
          "&resourceID=" +
          this.entryIDChosen
      );
      this.app.presentToast("Link copied", "success");
    }

    console.log("TOKEN >>> ", this.copyLinkAPChosen);
    this.copyLinkAPChosen = null;
  }

  getDeviceData() {
    //'?join=company_slides,slide_id,id,name:src:type&orderby=priority+asc'
    this.http.apiGet("devices/company_id/" + this.app.sysData.company_id + "?orderby=name", null).then((data) => {
      console.log("Got Devices >>> ", data.data);
      this.deviceData = data.data;
    });
  }

  saveCategory(m, i) {
    if (m == 1) {
      //save new

      if (i == 0) {
        //new public category
        var obj = JSON.parse(JSON.stringify(this.flags.newPublicCategory));
        obj.site_id = this.flags.editSite.id; // add site id
        obj.entries = JSON.stringify(obj.entries);
        obj.settings = JSON.stringify(obj.settings);
        obj.type = 0;
      }

      if (i == 1) {
        //new private category
        var obj = JSON.parse(JSON.stringify(this.flags.newPrivateCategory));
        obj.site_id = this.flags.editSite.id; // add site id
        obj.entries = JSON.stringify(obj.entries);
        obj.settings = JSON.stringify(obj.settings);
        obj.type = 1;
      }

      this.http.apiPost("repo_categories/", { data: obj }, null).then((data) => {
        console.log("return save " + data);
        this.app.presentToast("Successully Posted", "success");
        this.reset(); //reset category input boxes
        this.getCategories();
      });
    }

    //SAVE EXISTING ITEM
    if (m == 1.1) {
      //existing category
      var obj = JSON.parse(JSON.stringify(this.flags.editCategory));
      obj.entries = JSON.stringify(obj.entries);
      obj.settings = JSON.stringify(obj.settings);

      this.http.apiPut("repo_categories/id/" + obj.id, { data: obj }, null).then((data) => {
        console.log("return save " + data);
        this.app.presentToast("Successully Updated", "success");
        this.getCategories();
      });
    }
  }

  deleteSite() {
    this.http.apiDelete("company_sites/id/" + this.flags.editSite.id, null).then((data) => {
      this.app.toast("Site deleted successfully", "success");
      this.viewPage(0, null);
    });
  }

  deleteCategory() {
    this.http.apiDelete("repo_categories/id/" + this.flags.editCategory.id, null).then((data) => {
      this.reset(); //reset category input boxes
      this.getCategories();
    });
  }

  //END CATEGORIES

  //ADDRESS SEARCH
  async searchLocation() {
    if (this.flags.editSite.address) {
      mapsAutocomplete(this.flags.editSite.address).then((data) => {
        console.log("Google results", data);
        this.flags.matches.googleResult = JSON.parse(JSON.stringify(data));
      });
    }
  }

  selectLocation(i) {
    this.flags.editSite.address = this.flags.matches.googleResult[i].structured_formatting.main_text;
    this.flags.editSite.place_id = this.flags.matches.googleResult[i].place_id;

    mapsLocationDetails(this.flags.matches.googleResult[i].place_id).then((data) => {
      console.log("Selection results ", data);

      //this.app.alert(obj[i].short_name);
      this.flags.editSite.lat = data[0].geometry.location.lat;
      this.flags.editSite.lng = data[0].geometry.location.lng;

      var obj = data[0].address_components;
      for (var i = 0; i < obj.length; i++) {
        for (var j = 0; j < obj[i].types.length; j++) {
          //if (obj[i].types[j] == "route") { this.flags.editPost.address = obj[i].long_name}

          if (obj[i].types[j] == "locality") {
            this.flags.editSite.city = obj[i].long_name;
          }
          if (obj[i].types[j] == "administrative_area_level_1") {
            this.flags.editSite.state = obj[i].long_name;
          }
          if (obj[i].types[j] == "country") {
            this.flags.editSite.country = obj[i].long_name;
          }
          if (obj[i].types[j] == "postal_code") {
            this.flags.editSite.zip = obj[i].short_name;
          }
        }
      }

      this.flags.matches.googleResult = [];
      this.flags.addressSearch = null;
    });
  }
  //END GOOGLE ADDRESS SEARCH

  saveSite(m) {
    var obj = JSON.parse(JSON.stringify(this.flags.editSite));
    obj.settings = JSON.stringify(obj.settings);
    obj.self_serve = JSON.stringify(obj.self_serve);
    obj.directory = JSON.stringify(obj.directory);
    obj.api_directory = JSON.stringify(obj.api_directory);
    obj.contacts = JSON.stringify(obj.contacts);

    if (m == 1) {
      //save new site
      obj.epoch = Date.now(); //set created date

      this.http.apiPost("company_sites", { data: obj }, null).then((data) => {
        this.app.toast("Saved", "success");
        //this.getSites();
        //this.reset();
      });
    }

    if (m == 1.1) {
      //update site
      this.http.apiPut("company_sites/id/" + obj.id, { data: obj }, null).then((data) => {
        this.app.toast("Saved", "success");
        //this.getSites();
        //this.reset();
      });
    }
  }

  checkIframe(index, url) {
    this.http.iframe(url).then((data) => {
      //this.app.alert('came back with ' + data);
      this.flags.editCategory.entries[index].iframe = data;
    });
  }

  uploadFile(m, files, i) {
    console.log("File upload 0", files);
    //this.app.alert('coming soon');
    //ACL: 'private'
    //ACL: 'public-read'
    //ACL: 'public-read-write'

    this.amplify
      .uploadFile(files, "public-read")
      .then((data) => {
        console.log("file uploaded", data);

        if (m == 1) {
          //upload to repo
          this.flags.editCategory.entries[i].target = this.app.sysData.s3Root + data["key"];
        }

        if (m == 2) {
          //upload to logo
          this.flags.editSite.settings.logo = this.app.sysData.s3Root + data["key"];
        }
        if (m == 2.1) {
          //upload to logo icon
          this.flags.editSite.settings.logoIcon = this.app.sysData.s3Root + data["key"];
        }

        if (m == 2.2) {
          //upload to logo Subpage
          this.flags.editSite.settings.logoSubpage = this.app.sysData.s3Root + data["key"];
        }

        if (m == 2.3) {
          //upload to selection screen
          this.flags.editSite.settings.selectBgImage = this.app.sysData.s3Root + data["key"];
        }

        if (m == 2.4) {
          //upload to direct control placeholder
          this.flags.editSite.settings.dcImage = this.app.sysData.s3Root + data["key"];
        }

        if (m == 2.5) {
          //upload to welvome video placeholder
          this.flags.editSite.settings.wVideo = this.app.sysData.s3Root + data["key"];
        }

        if (m == 2.6) {
          //upload to support video placeholder
          this.flags.editSite.settings.sVideo = this.app.sysData.s3Root + data["key"];
        }

        if (m == 2.7) {
          //upload to welcome screen image
          this.flags.editSite.settings.wImage = this.app.sysData.s3Root + data["key"];
          if (this.flags.editSite.settings.wImageLoop == null) {
            this.flags.editSite.settings.wImageLoop = 0;
          }
        }

        if (m == 3) {
          //upload to background
          this.flags.editSite.settings.bgImage = this.app.sysData.s3Root + data["key"];
        }

        if (m == 4) {
          //upload to contact iamge
          this.flags.editSite.settings.contactImg = this.app.sysData.s3Root + data["key"];
        }

        if (m == 5) {
          //upload to survey
          this.flags.editSite.settings.surveyImg = this.app.sysData.s3Root + data["key"];
        }

        if (m == 6) {
          //upload to category
          this.flags.modalItem.settings.bgImage = this.app.sysData.s3Root + data["key"];
        }

        if (m == 6.2) {
          //upload to category
          this.flags.modalItem.settings.realtorTemplateAvatar = this.app.sysData.s3Root + data["key"];
        }

        if (m == 6.3) {
          //upload to category
          this.flags.modalItem.settings.featuredPropertyImage = this.app.sysData.s3Root + data["key"];
        }

        if (m == 7) {
          //upload to category
          this.flags.modalItem.settings.wVideo = this.app.sysData.s3Root + data["key"];
        }
        if (m == 8.1) {
          //upload to upper ads
          this.flags.editSite.settings.upperAdvertisementList[i].target = this.app.sysData.s3Root + data["key"];
        }
        if (m == 8.2) {
          //upload to lower ads
          this.flags.editSite.settings.lowerAdvertisementList[i].target = this.app.sysData.s3Root + data["key"];
        }

        //this.flags.profileFocusData.ext = data['ext'];
        this.app.toast("File Uploaded", "success");
      })
      .catch((err) => {
        this.app.alert("Error | " + JSON.stringify(err));
        console.log("Error", err);
      });
  }

  deleteFile(m, file) {
    this.amplify.deleteFile(file).then((data) => {
      console.log("delted file response", data);

      if (m == 2.3) {
        //site selector image
        this.flags.editSite.settings.selectBgImage = null;
      }

      if (m == 6) {
        //upload to category
        this.flags.modalItem.settings.bgImage = null;
      }
    });
  }

  saveDesign(m) {
    console.log("SAVING MODAL " + m, this.flags.modalItem);
    console.log("saving Category ", this.flags.editCategory);
    //save categories
    if (m == 1) {
      this.flags.editCategory = JSON.parse(JSON.stringify(this.flags.modalItem));
      this.closeModal();
    }

    //save category entries
    if (m == 2) {
      var i = this.flags.editCategory.entries.findIndex((el) => el.id === this.flags.modalItem.id);
      var obj = JSON.parse(JSON.stringify(this.flags.modalItem));
      if (!obj.settings.catGlassmorphism) {
        obj.settings.catGlassmorphism = 0;
      }
      this.flags.editCategory.entries[i] = obj;

      this.closeModal();
    }
  }

  overwriteCategory() {
    this.flags.editCategory.entries = JSON.parse(this.flags.modalItem.editEntries);
    this.flags.editCategory.settings = JSON.parse(this.flags.modalItem.editSettings);
    this.closeModal();
  }

  overwriteSite() {
    this.flags.editSite.settings = JSON.parse(this.flags.modalItem.editSettings);
    this.flags.editSite.directory = JSON.parse(this.flags.modalItem.editDirectory);
    this.flags.editSite.contacts = JSON.parse(this.flags.modalItem.editContacts);
    this.closeModal();
  }

  openModal(m, item) {
    this.flags.modalMode = m;
    if (item != null) {
      this.flags.modalItem = JSON.parse(JSON.stringify(item));
    }

    console.log("OPEN MODAL", item);

    // if (
    //   this.app.sysData.company.industry == "real-estate" &&
    //   this.flags.modalItem.settings.buttonTemplate === "realtor"
    // ) {
    //   console.log("REALTOR TEMPLATE", this.flags.modalItem.settings, item);
    //   this.realtorTemplates = Object.entries(
    //     this.flags.modalItem.settings.realtorButtonTemplateBG[this.flags.editSite.settings.realtorCompany]
    //   ).map(([key, value]) => ({ label: key, path: value }));
    // }

    // if(m == 2 && !this.flags.modalItem.settings) {
    //   this.flags.modalItem.settings = { text: '', textOverride: false, textColor: '#333', textFont: 'Verdana', textSize: '20', bgColor: '#efefef', bgImage: null, width: '23%'};
    // }

    // if (m == 2 && item.type == 'email') {
    //   this.flags.modalItem.settings.bgImage = url()
    // }

    if (m == 3) {
      console.log("You OPENED THE MODAL FOR SITE SETTINGS 3", m, item);
      this.flags.modalItem.editEntries = JSON.stringify(this.flags.modalItem.entries);
      this.flags.modalItem.editSettings = JSON.stringify(this.flags.modalItem.settings);
    }

    if (m == 4) {
      console.log("You OPENED THE MODAL FOR SITE SETTINGS 4", m, item);
      this.flags.modalItem.editSettings = JSON.stringify(this.flags.modalItem.settings);
      this.flags.modalItem.editDirectory = JSON.stringify(this.flags.modalItem.directory);
      this.flags.modalItem.editContacts = JSON.stringify(this.flags.modalItem.contacts);
    }
  }

  closeModal() {
    this.flags.modalMode = null; //clear modal flag
  }

  onTemplateChange() {
    if (this.flags.modalItem.settings.buttonTemplate === "testimonial") {
      this.flags.modalItem.settings.bgImage = "assets/img/testimonial-template.png";
      this.flags.modalItem.settings.textSize = "14";
    } else if (this.flags.modalItem.settings.buttonTemplate === "property") {
      this.flags.modalItem.settings.textSize = "18";
    } else if (this.app.sysData.company.industry == "real-estate") {
      this.realtorTemplates = Object.entries(
        this.flags.modalItem.settings.realtorButtonTemplateBG[this.flags.editSite.settings.realtorCompany]
      ).map(([key, value]) => ({ label: key, path: value }));
    }
  }

  async loadMappedinDirectory() {
    const params = {
      venue: this.flags.editSite.settings.directory.venue,
      clientId: this.flags.editSite.settings.directory.id,
      clientSecret: this.flags.editSite.settings.directory.key,
    };

    mappedinDirectory(params).then((data) => {
      // const sortedCategories = [
      //   ...data.categories.sort((a, b) => (a.name! > b.name! ? 1 : 0))
      // ];

      this.flags.directoryListings = data.categories;
      console.log("SORTED CATS", data.categories);
    });
    console.log(params);
  }

  saveMappedInDirectory() {
    //NOT WORKING
    this.flags.directoryListings.forEach((category) => {
      category.entries = JSON.stringify(category.locations);
      category.entries = JSON.parse(category.entries);
    });

    console.log("before saving", this.flags.directoryListings);
    this.flags.editSite.api_directory = this.flags.directoryListings;

    console.log("after saving", this.flags.editSite.api_directory);

    this.app.toast("Directory listings updated Please Save Site to commit the changes", "dark");
  }

  previewWindow() {
    var id = this.flags.editSite.settings.directory.id;
    var key = this.flags.editSite.settings.directory.key;

    var src = "https://wecare.helloarii.com/assets/api-mappedin.html?id=" + id + "&key=" + key;
    window.open(src, "_blank", "width=800,height=600,left=150,top=200,toolbar=0,status=0,");
  }

  viewPage(m, id) {
    if (m == 0) {
      //this.router.navigateByUrl('/slides-folder/' + this.folder);
      this.location.back();
    }

    if (m == 1) {
      this.router.navigateByUrl("/mappedin");
    }

    if (m == 1.1) {
      this.router.navigateByUrl("/sites-edit/" + id);
    }

    if (m == 1.3) {
      this.router.navigateByUrl("/slides-edit/" + id);
    }
    if (m == 2) {
      this.router.navigateByUrl("/sites-assignment/" + id);
    }

    if (m == 3) {
      this.router.navigateByUrl("/sites-wizard/" + id);
    }

    if (m == 4) {
      //this.router.navigateByUrl(id);
      window.open(id);
    }
  }

  remSetting(m, i) {
    if (m == "category") {
      this.deleteCategory();
    }

    if (m == "site") {
      this.deleteSite();
    }

    if (m == 0) {
      this.flags.editCategory.entries.splice(i, 1);
    } //client buttons
    // if (m == 0) { this.flags.editSite.settings.supportButtons.splice(i, 1); } //client buttons
    if (m == 1) {
      this.flags.editSite.settings.repoLinks.splice(i, 1);
    } //support buttons (repo)
    if (m == 2) {
      this.flags.editSite.contacts.splice(i, 1);
    } //support contacts
    if (m == 3) {
      this.flags.editSite.directory.splice(i, 1);
    } //support directory
    if (m == 4) {
      this.flags.editSite.settings.upperAdvertisementList.splice(i, 1);
    } // upper ads
    if (m == 5) {
      this.flags.editSite.settings.lowerAdvertisementList.splice(i, 1);
    } // lower ads
    if (m == 6) {
      this.flags.editSite.settings.sessionReasonsList.splice(i, 1);
    } // lower ads
  }

  reorderSetting(m, e) {
    if (m == 0) {
      // reorder client button element
      let draggedItem = this.flags.editCategory.entries.splice(e.detail.from, 1)[0];
      this.flags.editCategory.entries.splice(e.detail.to, 0, draggedItem);
      e.detail.complete();
    }

    // if(m == 0) { // reorder client button element
    //     let draggedItem = this.flags.editSite.settings.supportButtons.splice(e.detail.from,1)[0];
    //     this.flags.editSite.settings.supportButtons.splice(e.detail.to,0,draggedItem)
    //     e.detail.complete();
    // }

    if (m == 1) {
      // support buttons (repo) button element
      let draggedItem = this.flags.editSite.settings.repoLinks.splice(e.detail.from, 1)[0];
      this.flags.editSite.settings.repoLinks.splice(e.detail.to, 0, draggedItem);
      e.detail.complete();
    }

    if (m == 2) {
      // contacts element
      let draggedItem = this.flags.editSite.contacts.splice(e.detail.from, 1)[0];
      this.flags.editSite.contacts.splice(e.detail.to, 0, draggedItem);
      e.detail.complete();
    }

    if (m == 3) {
      // contacts element
      let draggedItem = this.flags.editSite.directory.splice(e.detail.from, 1)[0];
      this.flags.editSite.directory.splice(e.detail.to, 0, draggedItem);
      e.detail.complete();
    }

    if (m == 4) {
      // upper ads element
      let draggedItem = this.flags.editSite.settings.upperAdvertisementList.splice(e.detail.from, 1)[0];
      this.flags.editSite.settings.upperAdvertisementList.splice(e.detail.to, 0, draggedItem);
      e.detail.complete();
    }

    if (m == 5) {
      // lower ads element
      let draggedItem = this.flags.editSite.settings.lowerAdvertisementList.splice(e.detail.from, 1)[0];
      this.flags.editSite.settings.lowerAdvertisementList.splice(e.detail.to, 0, draggedItem);
      e.detail.complete();
    }
    if (m == 6) {
      // Session Reasons Element
      let draggedItem = this.flags.editSite.settings.sessionReasonsList.splice(e.detail.from, 1)[0];
      this.flags.editSite.settings.sessionReasonsList.splice(e.detail.to, 0, draggedItem);
      e.detail.complete();
    }
  }

  async presentAlertConfirm(m, i) {
    if (m == "category") {
      const alert = await this.alertController.create({
        header: "Are you sure?",
        message:
          'You are about to delete the "' + this.flags.editCategory.name + '" folder. This action is irreversible.',
        buttons: [
          {
            text: "Cancel",
            role: "cancel",
            cssClass: "secondary",
            handler: (blah) => {
              console.log("Confirm Cancel: blah");
            },
          },
          {
            text: "Delete",
            handler: () => {
              this.remSetting(m, i);
              console.log("Confirm Okay");
            },
          },
        ],
      });
      await alert.present();
    } else if (m == 0) {
      const alert = await this.alertController.create({
        header: "Are you sure?",
        message: "You are about to delete this resource. This action is irreversible.",
        buttons: [
          {
            text: "Cancel",
            role: "cancel",
            cssClass: "secondary",
            handler: (blah) => {
              console.log("Confirm Cancel: blah");
            },
          },
          {
            text: "Delete",
            handler: () => {
              this.remSetting(m, i);
              console.log("Confirm Okay");
            },
          },
        ],
      });
      await alert.present();
    } else if (m == 2) {
      const alert = await this.alertController.create({
        header: "Are you sure?",
        message: "You are about to delete this contact. This action is irreversible.",
        buttons: [
          {
            text: "Cancel",
            role: "cancel",
            cssClass: "secondary",
            handler: (blah) => {
              console.log("Confirm Cancel: blah");
            },
          },
          {
            text: "Delete",
            handler: () => {
              this.remSetting(m, i);
              console.log("Confirm Okay");
            },
          },
        ],
      });
      await alert.present();
    } else if (m == 3) {
      const alert = await this.alertController.create({
        header: "Are you sure?",
        message: "You are about to delete this manual directory listing. This action is irreversible.",
        buttons: [
          {
            text: "Cancel",
            role: "cancel",
            cssClass: "secondary",
            handler: (blah) => {
              console.log("Confirm Cancel: blah");
            },
          },
          {
            text: "Delete",
            handler: () => {
              this.remSetting(m, i);
              console.log("Confirm Okay");
            },
          },
        ],
      });
      await alert.present();
    } else if (m == 4) {
      const alert = await this.alertController.create({
        header: "Are you sure?",
        message: "You are about to delete this advertisement for the upper banner. This action is irreversible.",
        buttons: [
          {
            text: "Cancel",
            role: "cancel",
            cssClass: "secondary",
            handler: (blah) => {
              console.log("Confirm Cancel: blah");
            },
          },
          {
            text: "Delete",
            handler: () => {
              this.remSetting(m, i);
              console.log("Confirm Okay");
            },
          },
        ],
      });
      await alert.present();
    } else if (m == 5) {
      const alert = await this.alertController.create({
        header: "Are you sure?",
        message: "You are about to delete this advertisement for the lower banner. This action is irreversible.",
        buttons: [
          {
            text: "Cancel",
            role: "cancel",
            cssClass: "secondary",
            handler: (blah) => {
              console.log("Confirm Cancel: blah");
            },
          },
          {
            text: "Delete",
            handler: () => {
              this.remSetting(m, i);
              console.log("Confirm Okay");
            },
          },
        ],
      });
      await alert.present();
    } else if (m == 6) {
      const alert = await this.alertController.create({
        header: "Are you sure?",
        message: "You are about to delete this reason. This action is irreversible.",
        buttons: [
          {
            text: "Cancel",
            role: "cancel",
            cssClass: "secondary",
            handler: (blah) => {
              console.log("Confirm Cancel: blah");
            },
          },
          {
            text: "Delete",
            handler: () => {
              this.remSetting(m, i);
              console.log("Confirm Okay");
            },
          },
        ],
      });
      await alert.present();
    } else {
      const alert = await this.alertController.create({
        header: "Are you sure?",
        message: "You are about to delete the " + this.flags.editSite.name + " archive. This action is irreversible.",
        buttons: [
          {
            text: "Cancel",
            role: "cancel",
            cssClass: "secondary",
            handler: (blah) => {
              console.log("Confirm Cancel: blah");
            },
          },
          {
            text: "Delete",
            handler: () => {
              this.remSetting(m, i);
              console.log("Confirm Okay");
            },
          },
        ],
      });
      await alert.present();
    }
  }

  ngOnInit() {
    this.getDeviceData();
  }
}
